export default {
  'enabled-locations-map': {
    locations: 'Ubicaciones',
    'find-my-location': 'Encontrar mi ubicación',
    'select-country': 'Seleccionar país',
    'all-countries': 'Todos los países',
    search: 'Buscar',
    filter: 'Filtrar por proveedor, ciudad, país o estado',
    'location-type': 'Tipo de ubicación',
    '100G-enabled': 'Compatible con 100G',
    'local-ix-available': 'IX local disponible',
    'mcr-enabled': 'Compatible con MCR',
    'mve-enabled': 'Compatible con MVE',
    'view-latency': 'Ver latencia',
    'enquire-about-this-location': 'Consultar sobre esta ubicación',
    'enabled-location': 'Ubicación habilitada',
    'extended-location': 'Ubicación extendida',
    'loading-locations': 'Cargando ubicaciones',
    'no-location-found': 'Ninguna ubicación cumple con los criterios de filtro',
    'closest-mp-enabled-location': 'La ubicación habilitada de Megaport más cercana es',
    'location-filter': 'Filtro de ubicación',
    'coming-soon': 'Próximamente',
    'enter-your-address': 'Ingresa tu dirección',
    'learn-about-enabled-extended-locations': 'Obtén más información sobre nuestras Ubicaciones Habilitadas y Extendidas',
    'megaport-supported-location-types': 'Megaport admite dos tipos de ubicaciones donde puedes acceder a nuestra red',
    'locations-by-distance': 'Ubicaciones por distancia',
    'map-showing-data-center-location': 'Mapa que muestra la ubicación del centro de datos',
  },
}
    
  
